import { render, staticRenderFns } from "./PowerCodeExplainerMain.vue?vue&type=template&id=5b0b0dfe&scoped=true"
import script from "./PowerCodeExplainerMain.vue?vue&type=script&lang=js"
export * from "./PowerCodeExplainerMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b0dfe",
  null
  
)

export default component.exports